export const PRESET_COLORS = [
  "#14b8a6",
  "#38bdf8",
  "#22d3ee",
  "#818cf8",
  "#a78bfa",
  "#ef4444",
  "#fb923c",
  "#f59e0b",
  "#facc15",
  "#f472b6",
  "#2dd4bf",
  "#a8a29e",
  "#94a3b8",
  "#64748b",
  "#334155",
  "#0f172a",
];

export const normalizeHexColor = (value, fallback = "#64748b") => {
  const raw = String(value || "").trim();
  const match = raw.match(/#?([0-9a-fA-F]{3,8})/);
  if (!match) return fallback;
  let hex = match[1];
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }
  hex = hex.slice(0, 6);
  return `#${hex.toLowerCase()}`;
};
